var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i_schedule_school_date_time 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3332 66.667C70.9355 66.667 74.6665 62.936 74.6665 58.3337C74.6665 53.7313 70.9355 50.0003 66.3332 50.0003C61.7308 50.0003 57.9998 53.7313 57.9998 58.3337C57.9998 62.936 61.7308 66.667 66.3332 66.667ZM66.3332 70.0003C72.7765 70.0003 77.9998 64.777 77.9998 58.3337C77.9998 51.8903 72.7765 46.667 66.3332 46.667C59.8898 46.667 54.6665 51.8903 54.6665 58.3337C54.6665 64.777 59.8898 70.0003 66.3332 70.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3332 52.5C67.2537 52.5 67.9998 53.2462 67.9998 54.1667V57.643L69.1783 58.8215C69.8292 59.4723 69.8292 60.5277 69.1783 61.1785C68.5275 61.8293 67.4722 61.8293 66.8213 61.1785L64.6665 59.0237V54.1667C64.6665 53.2462 65.4127 52.5 66.3332 52.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3332 38.3333H27.9998V41.6667H31.3332V38.3333ZM27.9998 35C26.1588 35 24.6665 36.4923 24.6665 38.3333V41.6667C24.6665 43.5077 26.1588 45 27.9998 45H31.3332C33.1742 45 34.6665 43.5077 34.6665 41.6667V38.3333C34.6665 36.4923 33.1742 35 31.3332 35H27.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6667 38.3333H41.3333V41.6667H44.6667V38.3333ZM41.3333 35C39.4923 35 38 36.4923 38 38.3333V41.6667C38 43.5077 39.4923 45 41.3333 45H44.6667C46.5077 45 48 43.5077 48 41.6667V38.3333C48 36.4923 46.5077 35 44.6667 35H41.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0002 38.3333H54.6668V41.6667H58.0002V38.3333ZM54.6668 35C52.8258 35 51.3335 36.4923 51.3335 38.3333V41.6667C51.3335 43.5077 52.8258 45 54.6668 45H58.0002C59.8412 45 61.3335 43.5077 61.3335 41.6667V38.3333C61.3335 36.4923 59.8412 35 58.0002 35H54.6668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3332 51.6663H27.9998V54.9997H31.3332V51.6663ZM27.9998 48.333C26.1588 48.333 24.6665 49.8253 24.6665 51.6663V54.9997C24.6665 56.8407 26.1588 58.333 27.9998 58.333H31.3332C33.1742 58.333 34.6665 56.8407 34.6665 54.9997V51.6663C34.6665 49.8253 33.1742 48.333 31.3332 48.333H27.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6667 51.6663H41.3333V54.9997H44.6667V51.6663ZM41.3333 48.333C39.4923 48.333 38 49.8253 38 51.6663V54.9997C38 56.8407 39.4923 58.333 41.3333 58.333H44.6667C46.5077 58.333 48 56.8407 48 54.9997V51.6663C48 49.8253 46.5077 48.333 44.6667 48.333H41.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 20C21.3333 19.0795 22.0795 18.3333 23 18.3333H31.3333V15H23C20.2386 15 18 17.2385 18 20V60C18 62.7615 20.2386 65 23 65H56.7578C56.0557 63.9933 55.5082 62.8707 55.1498 61.6667H23C22.0795 61.6667 21.3333 60.9205 21.3333 60V20ZM64.6667 46.7848C65.211 46.707 65.7675 46.6667 66.3333 46.6667C66.8992 46.6667 67.4557 46.707 68 46.7848V20C68 17.2387 65.7615 15 63 15H58V18.3333H63C63.9205 18.3333 64.6667 19.0795 64.6667 20V46.7848ZM34.6667 18.3333H52.2708V15H34.6667V18.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6665 15H34.6665V20C34.6665 20.9205 33.9203 21.6667 32.9998 21.6667C32.0793 21.6667 31.3332 20.9205 31.3332 20V15H22.9998C21.1589 15 19.6665 16.4924 19.6665 18.3333V26.6667C19.6665 28.5077 21.1589 30 22.9998 30H62.9998C64.8408 30 66.3332 28.5065 66.3332 26.6655V18.3343C66.3332 16.4935 64.8408 15 62.9998 15H57.9998V20C57.9998 20.9205 57.2537 21.6667 56.3332 21.6667C55.4127 21.6667 54.6665 20.9205 54.6665 20V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0002 30.0003H21.3335V26.667H68.0002V30.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28 11.6667C28 10.7462 28.7462 10 29.6667 10C30.5872 10 31.3333 10.7462 31.3333 11.6667V18.3333C31.3333 19.2538 30.5872 20 29.6667 20C28.7462 20 28 19.2538 28 18.3333V11.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M51.3335 11.6667C51.3335 10.7462 52.0797 10 53.0002 10C53.9207 10 54.6668 10.7462 54.6668 11.6667V18.3333C54.6668 19.2538 53.9207 20 53.0002 20C52.0797 20 51.3335 19.2538 51.3335 18.3333V11.6667Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.1dd62dd0195b99330409cffd911a8253.svg";
export { ForwardRef as ReactComponent };